// Share a Calculation Canvas: render the off-screen ShareCard to PNG and
// hand it to the OS share sheet (with the image file where supported),
// otherwise download the PNG. Cross-platform, no backend dependency.
import { toPng } from "html-to-image";
import { toast } from "sonner";
import i18n from "../i18n";

async function nodeToPngBlob(node) {
  const dataUrl = await toPng(node, {
    pixelRatio: 2,
    cacheBust: true,
    skipFonts: true,
    backgroundColor: "#0a0a0a",
  });
  const res = await fetch(dataUrl);
  return res.blob();
}

function fileName(widget) {
  const base = (widget?.share?.subject || widget?.title || "dealalert")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
  return `dealalert-${base || "analyse"}.png`;
}

export async function shareCalculationCard(node, widget) {
  const t = (k, d) => i18n.t(`ai:${k}`, { defaultValue: d });
  if (!node) return;
  let blob;
  try {
    blob = await nodeToPngBlob(node);
  } catch (e) {
    toast.error(t("calc.shareError", "Grafik konnte nicht erzeugt werden."));
    return;
  }
  const file = new File([blob], fileName(widget), { type: "image/png" });

  // 1) Native share sheet with the image file (mobile browsers)
  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: widget?.share?.headline || "DealAlert",
        text: widget?.share?.subject || widget?.title || "",
      });
      return;
    }
  } catch (e) {
    if (e?.name === "AbortError") return; // user cancelled — no fallback
  }

  // 2) Fallback: download the PNG
  try {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName(widget);
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success(t("calc.shareDownloaded", "Grafik gespeichert – jetzt teilen!"));
  } catch (e) {
    toast.error(t("calc.shareError", "Grafik konnte nicht erzeugt werden."));
  }
}
